import React, { useMemo } from 'react';
import { Section, SkeletonItem } from '@atlaskit/side-navigation';
import { useIntl } from '@atlassian/jira-intl';
import { MenuItem } from '@atlassian/jira-navigation-apps-sidebar-common/src/common/ui/menu-item/main.tsx';
import { getSystemNavigationPaths } from '@atlassian/jira-navigation-apps-sidebar-common/src/utils/get-navigation-path/system/index.tsx';
import { matchUrlPathname } from '@atlassian/jira-navigation-apps-sidebar-common/src/utils/url-matchers/index.tsx';
import { useFeatures } from '../../../controllers/features/index.tsx';
import messages from './messages.tsx';
import { isProjectRolesSelected } from './utils.tsx';

/**
 *  Returns Menu navigation respecting the current user permissions
 *  When updating this file, make sure to also update the following files if necessary:
 * - src/packages/navigation-apps/sidebar/common/src/controllers/use-navigation-path/system
 */
export const SecuritySection = () => {
	const { data: features } = useFeatures();
	const { formatMessage } = useIntl();

	const navigationPath = useMemo(() => getSystemNavigationPaths(), []);

	if (features == null) return <SkeletonItem />;

	const globalPermissionsPath = navigationPath.securityGlobalPermissions;

	return (
		<Section title={formatMessage(messages.securityGroup)}>
			{features.hasProjectRoles && (
				<MenuItem
					analytics={{ itemId: 'project-roles' }}
					href={navigationPath.securityProjectRoles}
					selectedOn={isProjectRolesSelected}
				>
					{formatMessage(messages.projectRoles)}
				</MenuItem>
			)}
			{features.hasGlobalPermissions && (
				<MenuItem
					analytics={{ itemId: 'global-permissions' }}
					href={globalPermissionsPath}
					selectedOn={matchUrlPathname()}
				>
					{formatMessage(messages.globalPermissions)}
				</MenuItem>
			)}
		</Section>
	);
};
